/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsInsightsTopActionableVulnerability extends models.AppSecopsDashboardInsights {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsInsightsTopActionableVulnerability");
    }

    getFixupPrototypeFunction() { return AppSecopsInsightsTopActionableVulnerability.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsInsightsTopActionableVulnerability>): AppSecopsInsightsTopActionableVulnerability {
        let obj = Object.assign(new AppSecopsInsightsTopActionableVulnerability(), model);
        AppSecopsInsightsTopActionableVulnerability.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsInsightsTopActionableVulnerability>): AppSecopsInsightsTopActionableVulnerability {
        if (!model) return null;
        return AppSecopsInsightsTopActionableVulnerability.newInstance(<AppSecopsInsightsTopActionableVulnerability> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsInsightsTopActionableVulnerability) {
        if (!obj) return;

        models.AppSecopsInsightsTopActionableVulnerability.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsInsightsTopActionableVulnerability): boolean {
        if (models.AppSecopsDashboardInsights.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsInsightsTopActionableVulnerability.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.epss_score === undefined) {
            this.epss_score = 0;
        }
        if (this.overall_risk_score === undefined) {
            this.overall_risk_score = 0;
        }
        if (this.cvss_metric) {
            models.AppSecopsVulnerabilityCvssMetric.fixupPrototype(this.cvss_metric);
        }
        if (this.components) {
            for (let val of this.components) {
                models.AppSecopsSbomVulnerabilityComponentDetail.fixupPrototype(val);
            }
        }
        if (this.references) {
            for (let val of this.references) {
                models.AppSecopsExternalReferenceDetail.fixupPrototype(val);
            }
        }
        if (this.application_bcs_details) {
            for (let val of this.application_bcs_details) {
                models.AppSecopsApplicationBCSInfo.fixupPrototype(val);
            }
        }
    }

    /**
     * List of alternative identifiers for the vulnerability
     */
    aliases: Array<string>;

    /**
     * List of application ID(s) to which the vulnerability is associated
     */
    application_ids: Array<string>;

    /**
     * List of project ID(s) to which the vulnerability is associated
     */
    appsecops_project_id: Array<string>;

    /**
     * Component type associated with the vulnerability
     */
    component_type: Array<string>;

    /**
     * CVE identifier associated with the vulnerability
     */
    cve_id: string;

    cvss_metric: models.AppSecopsVulnerabilityCvssMetric;

    /**
     * Description about the vulnerability
     */
    description: string;

    /**
     * List of Common Platform Enumeration (CPE) identifier for the component
     */
    cpe: Array<string>;

    /**
     * EPSS score indicating the likelihood of exploitation (0 to 1)
     */
    epss_score: number;

    components: Array<models.AppSecopsSbomVulnerabilityComponentDetail>;

    /**
     * Indicates whether the vulnerability is a Known Exploited Vulnerability (KEV)
     */
    is_kev: string;

    /**
     * Aggregated risk score representing the overall impact of the vulnerability, considering multiple risk factors.
     */
    overall_risk_score: number;

    /**
     * Product(s) associated with the vulnerability
     */
    product: Array<string>;

    /**
     * List of Portfolio ID(s) associated with the vulnerability
     */
    portfolio_ids: Array<string>;

    /**
     * Package name to which the vulnerability is associated
     */
    package_name: Array<string>;

    references: Array<models.AppSecopsExternalReferenceDetail>;

    /**
     * List of Reference ID(s) to the SBOM used to detect vulnerabilities in software components
     */
    sbom_version_ids: Array<string>;

    /**
     * Unique ID for the vulnerability
     */
    vulnerability_id: string;

    /**
     * BCS details per application associated with the vulnerability
     */
    application_bcs_details: Array<models.AppSecopsApplicationBCSInfo>;

}
